import {Mail} from 'lucide-react'
import { useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { lumi } from '../lib/lumi'

export default function Newsletter() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setLoading(true)
    try {
      // Check if already subscribed
      const existing = await lumi.entities.newsletterSubscribers.list({
        filter: { email }
      })

      if (existing.list.length > 0) {
        if (existing.list[0].status === 'active') {
          toast.error('This email is already subscribed!')
        } else {
          // Reactivate subscription
          await lumi.entities.newsletterSubscribers.update(existing.list[0].id, {
            status: 'active',
            subscribedAt: new Date().toISOString()
          })
          toast.success('Welcome back! Your subscription has been reactivated.')
        }
      } else {
        // New subscription
        await lumi.entities.newsletterSubscribers.create({
          email,
          subscribedAt: new Date().toISOString(),
          status: 'active',
          userId: lumi.auth.user?.id || null,
          source: window.location.pathname
        })
        toast.success('Thank you for subscribing! Check your inbox for exclusive codes.')
      }
      setEmail('')
    } catch (error) {
      console.error('Subscription error:', error)
      toast.error('Failed to subscribe. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Toaster position="top-center" />
      <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 md:p-12 border-2 border-green-200">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-br from-green-600 to-blue-600 p-3 rounded-full">
              <Mail className="w-8 h-8 text-white" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Get the latest Glen Codes sent to your inbox
          </h2>
          <p className="text-gray-600 mb-6">
            Never miss a deal! Subscribe now for exclusive promo codes and limited-time offers.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-3 rounded-lg border-2 border-green-300 focus:border-green-500 focus:outline-none text-gray-900"
            />
            <button
              type="submit"
              className="px-8 py-3 bg-gradient-to-r from-green-600 to-blue-600 text-white font-semibold rounded-lg hover:from-green-700 hover:to-blue-700 transition-all shadow-md hover:shadow-lg"
            >
              Subscribe
            </button>
          </form>
          <p className="text-xs text-gray-500 mt-4">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </>
  )
}
